import { toast } from 'react-toastify';
import { DataFileEntity, FileData } from 'v2/DataFiles/models';
import { Avatar } from 'v2/models';
import { downloadFileFromUrl } from './downloadFileFromUrl';
import restFactory from './restFactory';

export function getSavedFileData(
  data: DataFileEntity | undefined | null
): FileData {
  if (data) {
    return {
      ext: data.file_name,
      id: null,
      name: data.file_name,
      size: bytesToSize(data.file_size),
      url: '',
    };
  }
  return {
    ext: '',
    id: null,
    name: '',
    size: '0',
    url: '',
  };
}
export function geFileData(uploadedFile: File): FileData {
  const regexAll = /[^\\]*\.(\w+)$/;
  const [name, ext] = uploadedFile.name.match(regexAll) as RegExpMatchArray;
  const file = {
    ext,
    id: null,
    name,
    size: bytesToSize(uploadedFile.size),
    url: '',
  };
  return file;
}

export function bytesToSize(bytes: number): string {
  const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i: number = parseInt(
    Math.floor(Math.log(bytes) / Math.log(1000)).toString()
  );
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / Math.pow(1000, i)).toFixed(1)} ${sizes[i]}`;
}

export function onFileSelected(callback: (file: File) => void) {
  const FILE_LIMIT = 50000000; // 50mMB
  return (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 0 || acceptedFiles.length > 1) {
      toast.error('Please upload no more than one file at a time.');
      return;
    }
    if (acceptedFiles[0].size > FILE_LIMIT) {
      toast.error('Uploads cannot be larger than 50MB');
      return;
    }
    callback(acceptedFiles[0]);
  };
}

export function getUrlFromFile(file: File): Promise<string | null> {
  return new Promise((response) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      response(reader.result as string);
    });
    reader.readAsDataURL(file);
  });
}

export function getRoundedCanvas(sourceCanvas: HTMLCanvasElement) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d') as CanvasRenderingContext2D;
  const width = sourceCanvas.width;
  const height = sourceCanvas.height;

  canvas.width = width;
  canvas.height = height;
  context.imageSmoothingEnabled = true;
  context.drawImage(sourceCanvas, 0, 0, width, height);
  context.globalCompositeOperation = 'destination-in';
  context.beginPath();
  context.arc(
    width / 2,
    height / 2,
    Math.min(width, height) / 2,
    0,
    2 * Math.PI,
    true
  );
  context.fill();
  return canvas;
}

export function base64StringtoFile(base64String: string, filename: string) {
  const arr = base64String.split(',');
  const matchedPattern = arr[0].match(/:(.*?);/);
  if (matchedPattern && matchedPattern.length > 1) {
    const mime = matchedPattern[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  return null;
}

export const downloadFile = async (id: number | string) => {
  const response = await restFactory.get<DataFileEntity>(`data-files/${id}`);
  downloadFileFromUrl(response.file);
};

export const uploadFile = async (file: File) => {
  const bodyFormData = new FormData();
  bodyFormData.append('files', file);
  bodyFormData.append('fileInfo', JSON.stringify({ name: file.name }));
  const [response] = await restFactory.post<Avatar[]>(`upload`, bodyFormData, {
    'Content-Type': 'multipart/form-data',
  });
  return response;
};
